import React from "react";
import PropTypes from "prop-types";
import P from "../Typography/P";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "../Radio";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "../FormControlLabel";
import dictionary from "../../../dictionary";

import styles from "./radio-group.module.scss";

function PillowCase(props) {
  const {onChange, name, current, content} = props;
  return (
    <div className={styles.root}>
      <FormControl component="fieldset" className={styles.fieldset}>
        <FormLabel component="legend">
          <P size="small" className={styles.legend}>
            Наволочки в наличии
          </P>
        </FormLabel>
        <RadioGroup
          defaultValue={current}
          value={current}
          aria-label={name}
          className={styles.group}
          onChange={(event) => onChange(name, event.target.value)}
        >
          {content.map(({value, label, disabled}) => (
            <FormControlLabel
              key={`${name}-${value}`}
              className={styles.radio}
              value={value}
              control={
                <Radio disabled={disabled} checked={current === value} />
              }
              label={
                <span className={styles.label}>
                  {dictionary.item.pillowCase[label]}
                </span>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
}

PillowCase.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default PillowCase;
